import { BoxLoading } from 'react-loadingg';

const Loading = () => (
    <div>
        <BoxLoading />;
    </div>
);

export default Loading;
